export default __webpack_public_path__ + "static/media/avacado.83d90d60.png";